import { create } from 'zustand'
import type { User } from '../types'

interface AuthStore {
  user: User | null
  loading: boolean
  setUser: (user: User | null) => void
  setLoading: (loading: boolean) => void
}

// Auth state is server-truth — do NOT persist. Hydration runs in App on
// mount via getMe(); a stale localStorage copy would cause flashes of the
// wrong UI.
export const useAuthStore = create<AuthStore>()((set) => ({
  user: null,
  loading: true,
  setUser: (user) => set({ user, loading: false }),
  setLoading: (loading) => set({ loading }),
}))
